const rawBase = import.meta.env.BASE_URL || "/";
const trimmedBase =
  rawBase === "/" ? "/" : rawBase.replace(/\/+$/, "") || "/";
const assetPrefix = trimmedBase === "/" ? "" : trimmedBase;

export const routerBasename = trimmedBase;

const isAbsoluteUrl = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;

export const withBasePath = (path = "/") => {
  if (!path) {
    return assetPrefix || "/";
  }

  if (isAbsoluteUrl.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (!assetPrefix) {
    return normalizedPath;
  }

  return `${assetPrefix}${normalizedPath}`;
};
